import signalTrackerListener from 'listeners/lib/signalTrackerListener';
import { datapointMiddleware } from 'middlewares';
import { errorThatWillCauseAlert } from 'owa-trace';
import { initializeLogger } from 'bootstrap';
import { logListener } from 'listeners';
import { perfAndReliabilityListener } from 'listeners/lib/perfAndReliabilityListener';
import { registerListener, registerMiddleware } from 'mini-app-context';

/**
 * Common initializations to be done before any module boot
 */
export const initializeAppState = (): Promise<void> =>
    new Promise(resolve => {
        try {
            initializeLogger();

            registerMiddleware(datapointMiddleware);

            registerListener(signalTrackerListener);
            registerListener(logListener);
            registerListener(perfAndReliabilityListener);
        } catch (error) {
            errorThatWillCauseAlert(`[initializeAppState] error occurred: ${error.message}`);
        } finally {
            resolve();
        }
    });
